module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/main_card_background_big.3303a123.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/main_card_background_big.jpg
// module id = 3012
// module chunks = 11